// ======================================================================
// File Name       : ServiceNoticeDetailUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import TableHead from '../../TableHead';
import RenderField from '../../../utils/ReduxFormUtils';

const thead = [
  { title: 'ログインID', sortBy: null },
  { title: 'ユーザー名', sortBy: null },
  { title: '所属グループ名', sortBy: null },
];

class ServiceNoticeDetailUserList extends React.Component {
  render() {
    const { serviceDetailUserList } = this.props;
    let tbody = null;
    if (serviceDetailUserList && serviceDetailUserList.length) {
      tbody = serviceDetailUserList.map((user, index) => (
        <tr key={index}>
          <td className="text-left">{user.loginId}</td>
          <td className="text-left">{user.userName}</td>
          <td className="text-left">{user.groupNames}</td>
        </tr>
      ));
    }
    return (
      <Col sm={12} className="padding-left-right-clear padding-top-10">
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </Col>
    );
  }
}

export default ServiceNoticeDetailUserList;
